import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { API_URL } from '../../../config';
import ApiService from '../../../services/ApiService';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue';
import CustomInput from '../../../components/Elements/input/customInput';
import CustomLink from '../../../components/Elements/Link/link';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CourseDetail from '../../coursDetail/courseDetail';
import Discount from '../../summary/discount/discount';
import GetContract from '../../summary/contract/getContract/getContract';
import UserDetailPopUp from '../../../components/Elements/userDetailPopUp/userDetailPopUp';

import axios from 'axios';
import AcceptInput from '../../chooseUserBuy/accept/accept';
import "./CampUserCard.css"

let idLoader;

const CampUserCard = (props) => {
    const proxySendURL = `${API_URL}ProxySend`
    const camp = JSON.parse( localStorage.getItem("campHeadingFull"))
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } };
    const styles = camp.courseDanceStyle.split(",")
    const [accept, setAccept]=useState(false);
    const [marketing, setMarketing]=useState(false);
    const [msg, setMSG]=useState(false)
    let key = localStorage.getItem('keyURL');
    const history = useHistory();
    const [isPAymentReady, sePaymentReady] = useState(0)
    const apiService = ApiService.getInstance();
let amount1 = 0;
// console.log(props.dataToSend.choosenPayVarian.paymentShedule)
props.dataToSend.choosenPayVarian.paymentShedule.map((shedule)=>{
    if(props.dataToSend.choosenInstallmet.includes(shedule.countNumber)){
        amount1 += shedule.paymentPositionPrice
    }
})
const [markieingConsent, setMarkieingConsent] =  useState({
    marketingAgreement: false,
    consentReceiveSmsEmailPhone: false,
  
})
const startLoaderTask = (taskConfig = null) => {
    if (
        typeof window.edsLoader === 'object' &&
        typeof window.edsLoader.startTask === 'function'
    ) {
        return window.edsLoader.startTask(taskConfig);
    } else {
        return false;
    }
};
const stopLoaderTask = (taskId) => {
    if (
        typeof window.edsLoader === 'object' &&
        typeof window.edsLoader.endTask === 'function'
    ) {
        return window.edsLoader.endTask(taskId);
    } else {
        return false;
    }
};
let globalResponse;
const methodProxySend = () => {

    let urlParams = "https://aden-eds-portal-dev.azurewebsites.net/ThankYou"
    const formData = {
        type: 'Order',
        body: {
            guid:props.dataToSend.trackingId,
            orderType:'OrderCamp',
            allInstallments: props.dataToSend.choosenPayVarian.paymentShedule  ,
            paymentMethodsDVID: parseInt(props.dataToSend.choosenPaymentOption),
             paymentMethodsP24:props.dataToSend.paymentP24,
            //  paymentCardID: props.data.card,
             buyerNIP: props.dataToSend.nip.length != 0?props.dataToSend.nip:null,
             purchaseKey: key,
             returnUrl: urlParams,
             current_LocalizationsID: -1,
             contractPeriodFrom: camp.StartingDate,
             usersID: props.dataToSend.parcipient.length != 0? props.dataToSend.parcipient.usersID :props.dataToSend.res.usersID, // uczestnik
             payer_UsersID: props.dataToSend.res.usersID,                            // płatnik
             productsID: props.dataToSend.choosenPayVarian.productsID,
             coursesHeadingsID: parseInt(localStorage.getItem('coursesHeadingsID')),
             contractAmount:  props.dataToSend.choosenPayVarian.currentPrice,//calculateAmiunt(),//props.installment.currentPrice,
             paymentStatusesDVID: 1,
             arrayOfSelectedInstallments: props.dataToSend.choosenInstallmet.toString(),
             
             form: {
           
                
                
                courseAgeRangesDVID:props.dataToSend.userData.courseAgeRangesDVID,
                courseDanceStyleDVID:props.dataToSend.userData.courseDanceStyleDVID,
                school:props.dataToSend.userData.school,
                departure:props.dataToSend.userData.departure,
                diet:props.dataToSend.userData.diet,
                discription:props.dataToSend.userData.discription,
                }
            
            //  dataTo: props.installment.expirationDateTo,
        },
    };
    idLoader = startLoaderTask()
    axios
        .post(proxySendURL, formData, config)
        .then((response) => {
            globalResponse = response.data.requestId;
            if(response.data.recheck){
                methodProxyGetMessage();
            } else {
                document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
                if(response.data.message === 'Other created'){
                    
                    sePaymentReady(100)
                    
                }
                if(response.data.message === "Fault"){
                    // setMsg("Wystąpił nierozpoznany problem")
                    sePaymentReady(105)
                } 
                if(response.data.message == 'Other requested'){
                  
              
                     methodProxyGetMessage();
                }
            }
        })
        .catch(function (error) {
            sePaymentReady(40)
            // if (error.response.status == 401) {
            //     // history.push('/Error_ogolny');
            // }
        });
};

const methodProxyGetMessage = () => {
    const proxyGetMessageURL = `${API_URL}ProxyGetMessage?requestId=` + globalResponse;
    axios
        .get(proxyGetMessageURL, config)
        .then((proxyGetMessageUrlResponse) => {
    
            if (proxyGetMessageUrlResponse.data.recheck == false) {

   
                // document.getElementsByClassName("eds_loader_container")[0].style.display = "none"
                if(proxyGetMessageUrlResponse.data.responseBody.status == 400){
                    // history.push('/Error_ogolny');
                    sePaymentReady(40)
                }
          
                if(proxyGetMessageUrlResponse.data.responseBody.status == 200){
                    // stopLoaderTask(idLoader);
                
                    localStorage.setItem('contractSygnature',proxyGetMessageUrlResponse.data.responseBody.body.contractSygnature);
                    props.next()
                    
            
                } else if(proxyGetMessageUrlResponse.data.responseBody.body.key === 20){
                  
                    props.next()
                }else{
                   
                    props.next()

                    // setMsg('Podczas tworzenia umowy wystąpił problem. Skontaktuj się z buirem obsługi klienta w celu dalszych wyjaśnień.');
                }
            } else if (proxyGetMessageUrlResponse.data.recheck == true) {
                setTimeout(() => methodProxyGetMessage(), 10000);
            }
        })
        .catch(function (error) {
          
            if (error.response != null) {
                if (error.response.status == 401) {
                    // history.push('/Error_ogolny');
                }
            } else {
                // window.location.replace(
                //     'https://aden-eds-portal-dev.azurewebsites.net/#/Error_ogolny'
                // );
            }
        });
};
    return <> 
    <div className='wrraperCamp'>
    {isPAymentReady==0?<div className="campAcceptTerm">
         <div className="campAcceptWrrap">
            <CustomTittle>Ponieżej znajdziesz dokumenty do pobrania</CustomTittle>
            <p className="studentCardText marginTop20">Przypominamy o obowiązku wypełnienia karty uczestnika,</p>
            <p className="studentCardText">którą trzeba dostarczyć w dniu wyjazdu</p>
            <div className="campDocumentWrapper">
                <GetContract titlePDF='Karta Uczestnika' elementID="elem" showContract={()=>{console.log("regulamin")}}>Umowa Lorem ipsuma</GetContract>
                <GetContract titlePDF='Regulamin obozu' elementID="elem" showContract={()=>{console.log("regulamin")}}>Umowa Lorem ipsuma</GetContract>
            </div>  
            <div className="campAcceptWrrap marginTop40">
            <p className='acceptContract_tittle'>Przeczytaj je, a następnie zaakceptuj zgody:</p>
            <div className='acceptContract'>
            
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setAccept(!e); if(markieingConsent.consentReceiveSmsEmailPhone&&markieingConsent.marketingAgreement){setMSG(false)}}} label="* Akceptuję"></AcceptInput><CustomLink link="/Statue">Regulamin</CustomLink></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setMarkieingConsent({...markieingConsent,...{consentReceiveSmsEmailPhone: !e}},);if(markieingConsent.marketingAgreement&&accept){setMSG(false)}}} label="Wyrażam zgodę na otrzymywanie informacji marketingowych i handlowych drogą elektroniczną, za pośrednictwem automatycznych systemów wywołujących oraz telefonicznie z wykorzystaniem telekomunikacyjnych urządzeń końcowych."></AcceptInput></div>
            <div className='acceptrContractLabel'><AcceptInput onAccept={(e) => {setMarkieingConsent({...markieingConsent,...{marketingAgreement: !e}});if(markieingConsent.consentReceiveSmsEmailPhone&&accept){setMSG(false)}}} label="Wyrażam zgodę na przetwarzanie moich danych osobowych w celach marketingowych promujących towary i usługi Administratora, a także w celach promujących towary i usługi partnerów, których lista dostępna jest pod adresem strony www.egurrola.com/partnerzy/."></AcceptInput></div>
            {msg?<p className="msgInvalid">*Zaakaceptuj regulamin żeby przejść dalej</p>:""}
                 </div>
                 </div>
               
                </div>  
        
    
    
            <CustomButtons clickFunction={()=>{
                let consent = {
                    usersID: props.dataToSend.res.usersID,
                    marketingAgreement: markieingConsent.marketingAgreement,
                    consentReceiveSmsEmailPhone: markieingConsent.consentReceiveSmsEmailPhone,
                };
           
                apiService.apiPost(
                    'UpdateUserConsents',
                    consent,
                    (response) => {
                        
                    },
                    false
                );
                if(accept){
                methodProxySend()}else{
                    setMSG(true)
                }
                //  if(accept){props.next()}else{setMSG(true)}
                }} classButton="solid" size="big">PRZEJDŹ DALEJ</CustomButtons>
               
    </div> :"" }   
    <div className='columDetials'>
    
<div className='columDetials_wrapper'>
             <CustomTittle>Szczegóły zamówienia  </CustomTittle>
             <CourseDetail wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
             <UserDetailPopUp
                                
                                title="Wariant cenowy:"
                                label={
                                    "płatność ratalna"
                                }
                                onclick={()=>{props.setNavigator(2)}}
                                icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }
                               
                    ></UserDetailPopUp>
                {
                
                  Object.keys(props.paymentMethodList).map((key, index) => (
                    props.paymentMethodList[key]?
                    <UserDetailPopUp
                                
                                  title="Forma płatności: "
                                  label={
                                    key
                                  }
                                  onclick={()=>{props.setNavigator(3)}}
                                  icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                
                    ></UserDetailPopUp>:""
                  ))
                }
                {props.nip?<UserDetailPopUp
                                
                                title="NIP do paragonu: "
                                label={
                                    "Tak"
                                }
                                onclick={()=>{props.setNavigator(3)}}
                                icon={<svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.3107 0.821234C14.1866 0.836124 14.0714 0.892748 13.9838 0.981809L5.72673 9.23891C5.64421 9.32133 5.58996 9.42774 5.57184 9.5428L5.20489 11.9283C5.179 12.1017 5.23733 12.2771 5.36186 12.4006C5.48649 12.524 5.66243 12.5807 5.83562 12.5532L8.221 12.1863C8.33614 12.1681 8.44256 12.1139 8.52499 12.0315L16.7821 3.77437C16.884 3.67127 16.9411 3.53223 16.9411 3.38732C16.9411 3.2424 16.884 3.10326 16.7821 3.00026L14.7637 0.981838C14.6452 0.861763 14.4783 0.802579 14.3107 0.821263L14.3107 0.821234ZM14.3737 2.14586L15.6123 3.39014L7.87121 11.1313L6.40896 11.3549L6.6326 9.88699L14.3737 2.14586ZM0.921326 2.28917C0.785505 2.3034 0.659824 2.36761 0.568699 2.46938C0.477574 2.57115 0.427474 2.70308 0.428231 2.83966V16.785C0.428231 16.9309 0.486276 17.0709 0.589469 17.1742C0.692756 17.2774 0.83276 17.3354 0.978711 17.3354H14.924C15.07 17.3354 15.21 17.2774 15.3133 17.1742C15.4165 17.0709 15.4745 16.9309 15.4745 16.785V7.24343C15.4766 7.09613 15.4195 6.95405 15.316 6.84916C15.2125 6.74417 15.0713 6.68517 14.924 6.68517C14.7766 6.68517 14.6354 6.74417 14.532 6.84916C14.4285 6.95406 14.3714 7.09614 14.3735 7.24343V16.2345H1.52908V3.3901H10.5202C10.6675 3.39219 10.8096 3.33509 10.9144 3.23161C11.0193 3.12823 11.0784 2.98701 11.0784 2.8396C11.0784 2.69221 11.0193 2.55108 10.9144 2.44759C10.8095 2.34412 10.6675 2.28702 10.5202 2.28911H0.978638C0.959574 2.28816 0.940415 2.28816 0.921256 2.28911L0.921326 2.28917Z" fill="#CC0033"/>
                </svg>
                }
                               
                    ></UserDetailPopUp>:""}
                    <div className='Installment_summary'>
          <div className='Installment_summaryDetails'> 
         
            <div className='amountInstallment'><p>DO ZAPŁATY:</p>    { <p>{amount1.toFixed(2).toString().replace(".",",")} ZŁ</p>}</div>
          </div> </div> 
 </div>
</div>
</div>
</>;
    }

export default CampUserCard;
